import '../../assets/css/Communications/Communications.css'
import {Outlet} from "react-router-dom";

const Communications = () => {
    return (
        <>
            <Outlet />

        </>

    )
}

export default Communications